import {updateFactory, Reducer} from '@modifi/redux'
import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {aPush} from '@modifi/router'
import {aCloseDialog} from '@modifi/plugin-dialogs'

import {aFetchIntermediaryShareholders} from '../../data/intermediary-shareholders'
import {aFetchInputFields} from '../../data/input-fields'

import {ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS} from '../../routes/constants'

const apiClient = getAuthenticatedThemisClient()

const {actions, selectors, reducer} = updateFactory({
  rootSelector: state => state?.features?.deleteShareholdingCompany,
  actionNamePrefix: 'features/intermediary-shareholding-company/delete',
  submitRequest:
    (a, externalShareholdingCompanyId: string) =>
    // eslint-disable-next-line consistent-return
    async (dispatch): Promise<any> => {
      dispatch(a.pendingAction())
      try {
        await apiClient.ShareholdingCompanies.delete({externalShareholdingCompanyId})
      } catch (error: any) {
        dispatch(a.errorAction(error))
        return null
      }
      dispatch(a.successAction())
      dispatch(aCloseDialog())
      await Promise.all([dispatch(aFetchInputFields()), dispatch(aFetchIntermediaryShareholders())])
      await dispatch(aPush(ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS))
    },
})

export default reducer as Reducer

export const {aSubmit: aDelete, aReset: aReset} = actions

export const {
  selectUpdatePending: selectDeleteIsPending,
  selectUpdateErrorMessage: selectDeleteErrorMessage,
} = selectors
